module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_MenuNarrow_16"],"path":[{"$":{"d":"M10,11v4H6V11ZM6,6v4h4V6ZM6,1V5h4V1Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_MenuNarrow_16.svg
// module id = USqB
// module chunks = 1